<template>
	<span
		v-if="visible"
		class="official-tag"
		:class="tagClass"
		:title="tagTitle"
	>
		<img
			v-if="showImage"
			:src="imageSrc"
			:alt="tagTitle"
			@error="onImageError"
		/>
		<template v-else>{{ displayText }}</template>
	</span>
</template>

<script>
import { hasUserTagImg, isOfficialUserTag, isPremiumUserTag, toUserTag } from '@/utils/userTag';

export default {
	name: "officialTag",
	props: {
		userTag: {
			type: [Number, String],
			default: 0
		},
		userTagImg: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "mini"
		}
	},
	data() {
		return {
			imageError: false
		};
	},
	watch: {
		userTagImg() {
			this.imageError = false;
		}
	},
	computed: {
		tagType() {
			return toUserTag(this.userTag);
		},
		isOfficial() {
			return isOfficialUserTag(this.tagType);
		},
		isPremium() {
			return isPremiumUserTag(this.tagType);
		},
		rawImg() {
			return hasUserTagImg(this.userTagImg) ? String(this.userTagImg).trim() : "";
		},
		imageSrc() {
			if (!this.rawImg || this.imageError) {
				return "";
			}
			return this.$mediaUrl(this.rawImg);
		},
		showImage() {
			return !!this.imageSrc;
		},
		displayText() {
			if (this.isOfficial) {
				return "官方人员";
			}
			if (this.isPremium) {
				return "高级用户";
			}
			return "";
		},
		visible() {
			return this.showImage || !!this.displayText;
		},
		tagClass() {
			return [
				'official-tag--' + this.size,
				{
					'official-tag-text': !this.showImage,
					'official-tag--blue': !this.showImage && this.isOfficial,
					'official-tag--yellow': !this.showImage && this.isPremium
				}
			];
		},
		tagTitle() {
			if (this.showImage) {
				return this.displayText || "标签";
			}
			return this.displayText;
		}
	},
	methods: {
		onImageError() {
			if (this.rawImg && !this.imageError) {
				this.imageError = true;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.official-tag {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	vertical-align: middle;
	pointer-events: none;
	line-height: 1;

	img {
		display: block;
		height: 100%;
		width: auto;
		max-width: 100%;
		object-fit: contain;
	}
}

.official-tag--mini {
	height: 28px;
	width: auto;
}

.official-tag--small {
	height: 32px;
	width: auto;
	max-width: 54px;
}

.official-tag--medium {
	height: 36px;
	width: auto;
}

.official-tag--large {
	height: 44px;
	width: auto;
}

.official-tag-text {
	height: auto;
	max-width: none;
	font-size: 12px;
	line-height: 16px;
	padding: 0 4px;
	border-radius: 2px;
	white-space: nowrap;
	font-weight: 600;
}

.official-tag-text.official-tag--small {
	font-size: 10px;
	line-height: 14px;
	padding: 0 3px;
}

.official-tag-text.official-tag--large {
	font-size: 14px;
	line-height: 22px;
	padding: 0 6px;
}

.official-tag--blue {
	color: #1890ff;
	background: #e6f7ff;
	border: 1px solid #91d5ff;
}

.official-tag--yellow {
	color: #d48806;
	background: #fff7e6;
	border: 1px solid #ffd591;
}
</style>
